import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import {
  AuthorMappingListPage,
  type AuthorMappingListSearch,
} from "@/components/admin/author-mapping/list-page";
import { mappingSearchSchema, mappingSuggestionsSearchSchema } from "@/lib/author-mapping";

/** `view=suggestions` shows the mapping suggestions instead of the author list. */
const searchSchema = mappingSearchSchema
  .extend(mappingSuggestionsSearchSchema.omit({ page: true }).shape)
  .extend({ view: z.enum(["suggestions"]).optional().catch(undefined) });

export const Route = createFileRoute("/_app/admin/author-mapping/")({
  validateSearch: searchSchema,
  component: Page,
});

function Page() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <AuthorMappingListPage
      search={search}
      onSearchChange={(patch: Partial<AuthorMappingListSearch>) =>
        void navigate({ search: (prev) => ({ ...prev, ...patch }) })
      }
    />
  );
}
